import { createSelector } from 'reselect'
import CreditSummaryModule, { CreditSummaryStateProps } from 'components/features/pfm/CreditSummaryModule/CreditSummaryModule'
import { Guards } from 'interfaces/guards'
import { connectShadedLoadable, createParallelGuard } from 'helpers/loadableHelpers'
import { memberInfoGuard, peergroupsGuard, selectedPeergroupTotalsGuard } from 'guards/globalGuards'
import { createSelectedTotalsByTypeSelector, selectedRelationSelector } from 'selectors/peergroupSelectors'
import { State } from 'interfaces/state'
import { TimeframeTyped } from 'interfaces/global'
import { TotalTyped } from 'interfaces/rank'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { withComparisonSelector } from 'components/features/pageFilters/selectors'

type CreditSummaryModuleContainerOwnProps = TimeframeTyped

const createMapStateToProps = () => {
  const typeProps: TotalTyped = { type: 'creditscore' }
  const peergroupTotalsSelector = createSelectedTotalsByTypeSelector()
  const boundPeergroupTotalsSelector = (state: State, ownProps: CreditSummaryModuleContainerOwnProps) =>
    peergroupTotalsSelector(state, { ...ownProps, ...typeProps })

  return createSelector(
    memberInfoSelector,
    boundPeergroupTotalsSelector,
    selectedRelationSelector,
    withComparisonSelector,
    (member, peergroupValues, selectedRelation, withComparison): CreditSummaryStateProps => {
      if (!member) {
        throw createForgottenGuardError('CreditSummaryModuleContainer', 'memberInfoGuard')
      }

      if (!peergroupValues) {
        throw createForgottenGuardError('CreditSummaryModuleContainer', 'selectedPeergroupTotalsGuard')
      }

      if (!selectedRelation) {
        throw createForgottenGuardError('CreditSummaryModuleContainer', 'peergroupsGuard')
      }

      const { is_creditfile_linked } = member
      return {
        selectedPeergroupName: selectedRelation.name,
        totals: {
          memberValue: is_creditfile_linked ? member.creditscore : null,
          peerValue: peergroupValues.peerValue.avg,
          otherValue: peergroupValues.otherValue.avg,
        },
        showLinkCreditButton: !is_creditfile_linked,
        withComparison,
      }
    }
  )
}

const creditSummaryGuards: Guards<CreditSummaryModuleContainerOwnProps> = [
  createParallelGuard(memberInfoGuard, peergroupsGuard),
  selectedPeergroupTotalsGuard,
]

const CreditSummaryModuleContainer = connectShadedLoadable<CreditSummaryStateProps, {}, {}, CreditSummaryModuleContainerOwnProps>(
  createMapStateToProps, undefined, creditSummaryGuards
)(CreditSummaryModule)
export default CreditSummaryModuleContainer
